const faqsRouter = [
    {
        path: "list-faqs",
        name: "list",
        component: () => import("@/views/admin/faqs"),
        default: true,
        meta: {
            model: "faqs",
            // requiresAuth: true,
        },
    },
    {
        path: "list-faqs/add",
        name: "add",
        component: () => import("@/views/admin/faqs/function"),
        default: true,
        meta: {
            model: "faqs",
            // requiresAuth: true,
        },
    },
    {
        path: "list-faqs/edit/:id",
        name: "edit",
        component: () => import("@/views/admin/faqs/function"),
        default: true,
        meta: {
            model: "faqs",
            // requiresAuth: true,
        },
    },
  ];
  export default faqsRouter;